if (!customElements.get('code-cart-items')) {
  customElements.define(
    'code-cart-items',
  class CodeCartItems extends HTMLElement {
    connectedCallback() {
      const sectionId = this.closest('code-cart-form').getAttribute('data-section-id');

      this.unsubscribe = subscribe('cartUpdate', ({ sections = {} }) => {
        const section = sections[sectionId];

        if (section) {
          const newCartItems = new DOMParser()
            .parseFromString(section, 'text/html')
            .querySelector(this.tagName.toLowerCase());

          const {
            item: items = [],
            empty: [empty],
          } = codeGetTargets(this);

          const {
            item: newItems = [],
            empty: [newEmpty],
          } = codeGetTargets(newCartItems);

          // Remove items
          items.filter((c) => !newItems.find((e) => e.dataset.key === c.dataset.key)).forEach((c) => c.remove());

          // Add items
          newItems
            .filter((e) => !items.find((c) => c.dataset.key === e.dataset.key))
            .forEach((e) => {
              const previous = items.find((c) => c.dataset.index === e.dataset.index - 1);

              if (previous) {
                previous.after(e);
              } else {
                this.prepend(e);
              }
            });

          // Update empty state
          empty.replaceWith(newEmpty);
        }
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
  });
}
